import { render, staticRenderFns } from "./SellingMethod.vue?vue&type=template&id=1bc5e95a&scoped=true&"
import script from "./SellingMethod.vue?vue&type=script&lang=js&"
export * from "./SellingMethod.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bc5e95a",
  null
  
)

export default component.exports